import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { GzButtonWebComponent } from '../../../ui/gzButton';
import { GzTextareaWebComponent } from '../../../ui/gzInput';
import { GzTitleWebComponent } from '../../../ui/gzTitle';
import { TemplateState } from '../../../types/common/types';
import { GzTextWebComponent } from '../../../ui/gzText';

export class NoteEditorView extends BaseWebComponentView {
  public dom: {
    $newNoteContainer: HTMLElement;
    $wrapper: HTMLElement;
    $noteEditorTextarea: GzTextareaWebComponent;
    $saveButton: GzButtonWebComponent;
    $cancelButton: GzButtonWebComponent;
    $noteTitle: GzTextWebComponent;
    $discardCancelButton: GzButtonWebComponent;
    $discardButton: GzButtonWebComponent;
    $cancelButtonFromDeletePanel: GzButtonWebComponent;
    $deleteButton: GzButtonWebComponent;
    $discardTitle: HTMLElement;
    $discardDescription: HTMLElement;
    $deleteTitle: HTMLElement;
    $deleteDescription: HTMLElement;
  };

  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$newNoteContainer = this.shadow.querySelector('.note-editor-container');
    this.dom.$noteEditorTextarea = this.shadow.querySelector('#notesPanelTextarea');
    this.dom.$cancelButton = this.shadow.querySelector('#cancelButton');
    this.dom.$saveButton = this.shadow.querySelector('#saveButton');
    this.dom.$noteTitle = this.shadow.querySelector('#noteTitle');
    this.dom.$discardCancelButton = this.shadow.querySelector('#discardCancelButton');
    this.dom.$discardButton = this.shadow.querySelector('#discardButton');
    this.dom.$cancelButtonFromDeletePanel = this.shadow.querySelector('#cancelButtonFromDeletePanel');
    this.dom.$deleteButton = this.shadow.querySelector('#deleteButton');
    this.dom.$discardTitle = this.shadow.querySelector('#discardTitle');
    this.dom.$discardDescription = this.shadow.querySelector('#discardDescription');
    this.dom.$discardButton = this.shadow.querySelector('#discardButton');
    this.dom.$deleteTitle = this.shadow.querySelector('#deleteTitle');
    this.dom.$deleteDescription = this.shadow.querySelector('#deleteDescription');

    this.setTranslatedStrings();
  }

  public buildSuccessView(data: any) {
    if (data.note.text) {
      this.dom.$noteEditorTextarea.value = data.note.text;
      this.dom.$noteTitle.textContent = this.dependencies.translateFn('Edit note');
      this.dom.$saveButton.textContent = this.dependencies.translateFn('Save#preserve state');
      return;
    }
    this.dom.$noteEditorTextarea.value = '';

    this.dom.$noteEditorTextarea.placeholder = this.dependencies.translateFn('Type your note');
    this.dom.$saveButton.textContent = this.dependencies.translateFn('Save#preserve state');
    this.dom.$noteTitle.textContent = this.dependencies.translateFn('New note');
  }

  public buildErrorView(error: Error) {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.ERROR);
  }

  public setTranslatedStrings() {
    this.dom.$cancelButton.textContent = this.dependencies.translateFn('Cancel');
    this.dom.$discardTitle.textContent = this.dependencies.translateFn('Discard changes?');
    this.dom.$discardDescription.textContent = this.dependencies.translateFn(
      'Are you sure you want to discard changes made to this note?'
    );
    this.dom.$discardButton.textContent = this.dependencies.translateFn('Discard');
    this.dom.$discardCancelButton.textContent = this.dependencies.translateFn('Cancel');
    this.dom.$deleteTitle.textContent = this.dependencies.translateFn('Delete note?');
    this.dom.$deleteDescription.textContent = this.dependencies.translateFn(
      'Are you sure you want to delete this note?'
    );
    this.dom.$deleteButton.textContent = this.dependencies.translateFn('Delete');
    this.dom.$cancelButtonFromDeletePanel.textContent = this.dependencies.translateFn('Cancel');
  }
}
